import React, {  useState } from "react";

import { Controller, useForm } from "react-hook-form";
import { Button, DatePicker, Input, TimePicker } from "antd";
import s from "./SetSchedule.module.scss";
import utc from "dayjs/plugin/utc";

import dayjs, { Dayjs } from "dayjs";
import clsx from "clsx";
import { generateResult } from "../../../../../../../../global components/ResultModal/ResultModal";
import ConfirmationModal from "../../../../../../../../global components/CofirmationModal/ConfirmationModal";
import ArrowDown from "../../../../../../../../global components/Icons/ArrowDown";
import ReactEmailEditor from "../ReactEmailEditor";
import ReusableModal from "../../../../../../../../global components/Modal/Modal";
import { BaselineCheckCircle } from "../../../../../../../../global components/Icons/BaseLineCheckCircle";
import { CloseIcon } from "../../../../../../../../global components/Icons/CloseIcon";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../../../libs/api/Endpoints";
import useSWRMutation from "swr/mutation";
import { SuccessDataType } from "../../../../../../../../libs/api/types";
import Card from "../Card";
import { UseAuthToken } from "../../../../../../../../libs/api/userSession";
dayjs.extend(utc);
type Inputs = {
  oneTimedate: string;
  oneTimetime: string;
};
type Prop = {
  handleNewGroup: () => void;
  mutate: () => void;
};
function SetSchedule({ handleNewGroup, mutate }: Prop) {
  const [open, setOpen] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);

  const [openEditor, setOpenEditor] = useState<boolean>(false);
  const [contentJSONDraft, setContentJSONDraft] = useState<any>();
  const [msgTitle, setMsgTitle] = useState<string>("");
  const [sentAt, setSentAt] = useState<string | null>(null);
  const token = UseAuthToken();
  const [contentHTMLDraft, setContentHTMLDraft] = useState<any>();
  const [userType, setUserType] = useState<
    "verified" | "unverified" | "pending" | "all" | null
  >(null);
  const toggleMainModal = () => setOpenModal((p) => !p);

  const { trigger: submitMessage, isMutating } = useSWRMutation(
    "api/admin/app-messages",
    swrMutationFetcher
  );
  const handleConfirmationModal = () => {
    setOpen((prev) => !prev);
  };
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<Inputs>({ shouldFocusError: false });

  const handleEditorModal = () => {
    setOpenEditor((prev) => !prev);
  };
  const handleEdit = (newContent: string, jsonFomat: any) => {
    setContentJSONDraft(jsonFomat);
    setContentHTMLDraft(newContent);
  };
  const handleValue = async () => {
    if (!msgTitle)
      return generateResult("error", "Enter a message title before sending");
    if (!contentJSONDraft)
      return generateResult("error", "Create a message before sending");

    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "POST",
          body: JSON.stringify({
            title: msgTitle,
            body: contentHTMLDraft,
            audience: userType,
            meta: contentJSONDraft,
            sentAt,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const result: SuccessDataType<any> = await submitMessage(fetcherArg);
      generateResult("success", result.message);
      handleEditorModal();
      mutate();
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error", e.message || "something went wrong");
    }
  };
  const combineDateTime = (
    date: string | Dayjs | null,
    time: string | Dayjs | null
  ) => {
    if (date && time) {
      const parsedDate = dayjs(date);
      const parsedTime = dayjs(time);

      if (parsedDate.isValid() && parsedTime.isValid()) {
        const combined = parsedDate
          .hour(parsedTime.hour())
          .minute(parsedTime.minute())
          .second(0)
          .millisecond(0);

        return combined.utc().toISOString(); // Converts explicitly to UTC
      }
    }
    return null;
  };

  const onSubmit = (data: Inputs) => {
    let startDate;
    if (!data.oneTimedate || !data.oneTimetime) {
      generateResult(
        "error",
        "Please select a date and time before creating a schedule"
      );
      return;
    }
    startDate = combineDateTime(data.oneTimedate, data.oneTimetime);
    setSentAt(startDate);
    handleNewGroup();
    toggleMainModal();
    // generateResult("success", "Schedule set successfully");
  };

  return (
    <>
      <ConfirmationModal
        handleCancel={handleNewGroup}
        open={open}
        reset={reset}
        handleConfirmationModal={handleConfirmationModal}
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={clsx(s.formWrapper, { [s.active]: true })}
      >
        <div className={clsx(s.form, { [s.active]: true })}>
          <div className={s.innerWraper}>
            <div
              className={clsx(s.oneTimeWrapper, {
                [s.notActive]: true,
              })}
            >
              <div className={s.scheduleWrapper}>
                <div className={clsx(s.inputWrapper)}>
                  <h5 className={clsx(s.inputLabel)}>Select date</h5>
                  <Controller
                    name="oneTimedate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        // value={
                        //   watch("date")
                        // } // Ensure value is a Day.js object or null
                        onChange={(date, dateString) => {
                          if (date) {
                            const isValidDate = dayjs(
                              date.toString()
                            ).isValid();
                            if (isValidDate) {
                              field.onChange(date); // Set the value if valid
                            } else {
                              field.onChange(null); // Clear the field if invalid
                            }
                          }
                        }}
                        value={
                          watch("oneTimedate")
                            ? dayjs(watch("oneTimedate"))
                            : null
                        } // Ensure value is a Day.js object
                        className={clsx(s.input, {
                          [s.inputError]: errors.oneTimedate,
                        })}
                        placeholder="MM/YYYY"
                        disabledDate={(current) => {
                          const today = dayjs(); // Current date
                          const ninetyDaysFromNow = today.add(90, "days"); // Date 90 days from today
                          return (
                            current &&
                            (current.isBefore(today, "day") ||
                              current.isAfter(ninetyDaysFromNow, "day"))
                          ); // Disable dates before today or beyond the next 90 days
                        }}
                      />
                    )}
                  />
                </div>
                <div className={clsx(s.inputWrapper)}>
                  <h5 className={clsx(s.inputLabel)}>Time</h5>
                  <Controller
                    name="oneTimetime"
                    control={control}
                    render={({ field }) => (
                      <TimePicker
                        className={clsx(s.input)}
                        onChange={(time, timeString) => {
                          if (time) {
                            field.onChange(time); // Set the value
                          }
                        }}
                        changeOnScroll
                        format="HH:mm"
                        needConfirm={true}
                        disabledHours={() => {
                          const selectedDate = watch("oneTimedate")
                            ? dayjs(watch("oneTimedate"))
                            : null;
                          const now = dayjs();

                          if (selectedDate && selectedDate.isSame(now, "day")) {
                            // Disable hours less than current hour
                            const hours = [];
                            for (let i = 0; i < now.hour(); i++) {
                              hours.push(i);
                            }
                            return hours;
                          }
                          return [];
                        }}
                        disabledMinutes={(selectedHour) => {
                          const selectedDate = watch("oneTimedate")
                            ? dayjs(watch("oneTimedate"))
                            : null;
                          const now = dayjs();

                          if (
                            selectedDate &&
                            selectedDate.isSame(now, "day") &&
                            selectedHour === now.hour()
                          ) {
                            // Disable minutes less than current minute for the current hour
                            const minutes = [];
                            for (let i = 0; i < now.minute(); i++) {
                              minutes.push(i);
                            }
                            return minutes;
                          }
                          return [];
                        }}
                        suffixIcon={
                          <ArrowDown height={16} width={16} fill="#6A6767" />
                        }
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={s.addContactBtns}>
            <Button
              type="default"
              className={clsx(s.button, s.cancelBtn)}
              onClick={handleConfirmationModal}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className={clsx(s.button, s.addContactBtn)}
            >
              Schedule
            </Button>
          </div>
        </div>
      </form>
      <ReusableModal
        title=""
        isModalOpen={openModal}
        handleModal={toggleMainModal}
      >
        <div className={s.cardWrapper}>
          {["all", "verified", "unverified", "pending"].map((type) => (
            <Card
              key={type}
              userType={
                type === "all"
                  ? "All users"
                  : type === "verified"
                  ? "Verified users"
                  : type === "unverified"
                  ? "Unverified users"
                  : "Pending users"
              }
              onClick={() => {
                setUserType(type as any);
                handleEditorModal();
              }}
            />
          ))}
        </div>
      </ReusableModal>

      <ReusableModal
        isModalOpen={openEditor}
        handleModal={handleEditorModal}
        footer={null}
        centered
        width={"90vw"}
        className={s.editorModal}
        closable={false}
        maskClosable={false}
        contentClassName={s.editorModal}
        title={
          <div className={s.header}>
            <Input
              value={msgTitle}
              count={{
                show: true,
                max: 80,
              }}
              className={clsx(s.input, {
                [s.inputError]: !msgTitle,
              })}
              maxLength={80}
              placeholder="This is the title or subject of email notifications."
              onChange={(e) => setMsgTitle(e.target.value)}
            />
            <div className={s.btnGroup}>
              <button onClick={handleEditorModal} className={s.closeBtn}>
                <CloseIcon />
                Cancel
              </button>
              <Button
                loading={isMutating}
                className={s.saveBtn}
                onClick={handleValue}
              >
                <BaselineCheckCircle />
                Schedule message
              </Button>
            </div>
          </div>
        }
        classNames={{
          body: s.modalBody,
          wrapper: s.modalWrapper,
          content: s.modalContent,
          footer: s.modalFooter,
          header: s.modalHeader,
          mask: s.modalMask,
        }}
      >
        <ReactEmailEditor
          handleEditorHTMLValue={handleEdit}
          jsonFormat={contentJSONDraft}
        />
      </ReusableModal>
    </>
  );
}

export default SetSchedule;
